import { performRequest, performRequestSecond, performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL, SetS3Config } from 'config/amplify_config';
import { Storage } from 'aws-amplify';
import { getTenantDetails } from 'utils/utils';
import { AppConfig } from 'config/api_config';

export const createFile = (data, is_lead = false, timeEntryData = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.fileManager.file}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${is_lead ? `&is_lead=${is_lead}` : ''}`,
    data,
    timeEntryData
  );
};

export const getFile = (params, pageLimit = 10, pagination_token = '', pagination_direction = 'forward') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.fileManager.file}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}${params}`
  );
};

export const updateFile = (data, is_lead = false, timeEntryData = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.fileManager.file}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${is_lead ? `&is_lead=${is_lead}` : ''}`,
    data,
    timeEntryData
  );
};

export const getSignedFile = async (entityFileInfo) => {
  const [tenantId] = getTenantDetails();
  const env = process.env.REACT_APP_ENV === 'dev' ? 'develop' : process.env.REACT_APP_ENV;
  const bucket = `lawft-documents-${tenantId}-${env}`;
  // let url = entityFileInfo?.file_path?.split('/');
  // SetS3Config(FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL);

  try {
    Storage.configure({
      bucket,
      level: '',
      region: process.env.REACT_APP_REGION,
      identityPoolId: process.env.REACT_APP_IDP_ID,
      customPrefix: { public: '' },
    });
    return await Storage.get(`${entityFileInfo.file_path}`, { download: true, useAccelerateEndpoint: true });
  } catch (err) {
    console.log(err);
  }
};

export const getSignedUrl = async (entityFileInfo) => {
  const [tenantId] = getTenantDetails();
  const env = process.env.REACT_APP_ENV === 'dev' ? 'develop' : process.env.REACT_APP_ENV;
  const bucket = `lawft-documents-${tenantId}-${env}`;

  // let url = entityFileInfo?.file_path?.split('/');
  // url?.shift();
  // SetS3Config(FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL);
  Storage.configure({
    bucket,
    level: '',
    region: process.env.REACT_APP_REGION,
    identityPoolId: process.env.REACT_APP_IDP_ID,
    customPrefix: { public: '' },
  });
  try {
    return await Storage.get(`${entityFileInfo.file_path}`, { useAccelerateEndpoint: true });
  } catch (err) {
    console.log(err);
  }
};

export const getFolders = (params) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.fileManager.file}/folders?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=100&${params}`
  );
};

export const getFileClients = (case_id = '') => {
  const [tenantId] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.fileManager.fileClients}?tenant_id=${tenantId}&case_id=${case_id}`
  );
};

export const sendESigantureRequest = (case_id, file_pk, file_sk, data, is_lead, timeEntryData = '') => {
  const [tenantId] = getTenantDetails();
  let filePk = file_pk ? file_pk.replaceAll('#', '%23') : '';
  let fileSk = file_sk ? file_sk.replaceAll('#', '%23') : '';
  //as an object {}
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.fileManager.sendESignature}?tenant_id=${tenantId}&case_id=${case_id}&file_pk=${filePk}&file_sk=${fileSk}${
      is_lead ? `&is_lead=${is_lead}` : ''
    }`,
    data,
    timeEntryData
  );
};

export const getFileDetails = (file_pk, file_sk) => {
  let filePK = file_pk ? file_pk.replaceAll('#', '%23') : '';
  let fileSK = file_sk ? file_sk.replaceAll('#', '%23') : '';
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.fileManager.getFile}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${filePK}&sk=${fileSK}`
  );
};

export const sendESigantureResponse = (case_id, file_pk, file_sk) => {
  const [tenantId] = getTenantDetails();
  let filePk = file_pk ? file_pk.replaceAll('#', '%23') : '';
  let fileSk = file_sk ? file_sk.replaceAll('#', '%23') : '';
  //as an object {}
  return performRequestSecond(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.fileManager.sendESignatureToAdmin}?tenant_id=${tenantId}&case_id=${case_id}&file_pk=${filePk}&file_sk=${fileSk}`
  );
};

export const fileTag = (data, is_lead = false, timeEntryData = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.fileManager.tagFile}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${is_lead ? `&is_lead=${is_lead}` : ''}`,
    data,
    timeEntryData
  );
};

export const getPresignedURL = (file_path, size = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  const extraHeaders = { 'x-api-key': AppConfig.presignedUrlHeaderKey };
  let url = `${apiEndPoints.getPresignedURL}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&file_path=${file_path}&file_size=${size}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url, null, '', true, false, extraHeaders);
};

export const presignedURLGet = async (
  file_path,
  version_id = false,
  is_profile_image = false,
  excludeFromLoading = false,
  file_sk = '',
  file_pk = ''
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.presignedURLGet}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&file_path=${encodeURI(file_path)}${
    version_id ? `&version_id=${version_id}` : ''
  }${is_profile_image ? `&is_profile_image=${is_profile_image}` : ''}${file_sk ? `&sk=${file_sk}` : ''}${file_pk ? `&pk=${file_pk}` : ''}`;

  try {
    return await performRequestSecond(apiEndPoints.methodType.GET, url, null, null, true, excludeFromLoading);
  } catch (error) {
    // Check if error status is 400 and retry once after 5 seconds
    if (error?.response?.status === 400) {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      return performRequestSecond(apiEndPoints.methodType.GET, url, null, null, true, excludeFromLoading);
    }
    // If not 400 error, throw the original error
    throw error;
  }
};

export const shareFile = (case_id, file_pk, file_sk, data, is_lead, timeEntryData = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let filePk = file_pk ? file_pk.replaceAll('#', '%23') : '';
  let fileSk = file_sk ? file_sk.replaceAll('#', '%23') : '';
  //as an object {}
  return performRequestSecond(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.fileSharing}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&case_id=${case_id}&file_pk=${filePk}&file_sk=${fileSk}${
      is_lead ? `&is_lead=${is_lead}` : ''
    }`,
    data,
    timeEntryData
  );
};

export const getTemplates = (params) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(apiEndPoints.methodType.GET, `/templates?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=100${params}`);
};

export const downloadFolders = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const { sk, folder_name, case_id } = data;
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.fileManager.getFolderContent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${case_id ? `&case_id=${case_id}` : ''}${
      sk ? `&sk=${sk}` : ''
    }${folder_name ? `&folder_name=${folder_name}` : ''}`
  );
};
